import ButtonsStep from "./buttons-step";

import image1 from '../assets/1.svg';
import image1hover from '../assets/1-hover.svg';
import image2 from '../assets/2-10.svg';
import image2hover from '../assets/2-10-hover.svg';
import image3 from '../assets/11-50.svg';
import image3hover from '../assets/11-50-hover.svg';
import image4 from '../assets/50.svg';
import image4hover from '../assets/50-hover.svg';

function Step3() {
    const stepTitle = `How many people work in your business?`;

    const stepElements = [
        {
            "text": "Just me",
            "image": image1,
            "imageHover": image1hover,
            "value": 1
        },
        {
            "text": "2 - 10 people",
            "image": image2,
            "imageHover": image2hover,
            "value": 2
        },
        {
            "text": "11 - 50 people",
            "image": image3,
            "imageHover": image3hover,
            "value": 3
        },
        {
            "text": "50+ people",
            "image": image4,
            "imageHover": image4hover,
            "value": 4
        },
    ];

    return (
        <>
            <h3 className='h2 fw-normal mb-5 text-center'>{stepTitle}</h3>
            <ButtonsStep stepElements={stepElements} stepTitle={stepTitle}></ButtonsStep>
        </>
    );
}

export default Step3;